/**
 * Created by Marcus Zhao on 10/19/2018.
 * Description:
 * Add contact dialog component
 * ------ maintenance history ------
 * Copy from contact-dialog-new compoent
 * update by Marcus 6/23/2021  support valid duplicate name and merge duplicate contact with email duplicate.
 * update by Alex 8/3/2022 - Add the feature of on the fly for office add-in.
 * update by Marcus 8/24/2022 - Support load signature data by create contact.
 * Update by Holly Li on 09/29/2022 - Handle international phone number formating.
 */
import { findPhoneNumbersInText, parsePhoneNumber } from 'libphonenumber-js';
import { OnInit, ElementRef, Component, OnDestroy, Input, Renderer2, HostListener } from '@angular/core';
import { Subscription, Subject, ReplaySubject, of, Observable, forkJoin } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { Contact } from '@tamalelibs/models/contact.model';
import { ContactViewModel } from '@tamalelibs/components/contact.view-model';
import { AlertWindowService } from '../../widgets/alert-window/alert-window.service';
import { ToastService } from '../../widgets/toast/toast.service';
import * as _lodash from 'lodash';
import { OpenDynamicComponentService } from '../../pages/home/home-open-dynamic-component';
import { lastCustomActionSelector } from '../../redux/reducers/action-history.reducer';
import { CREATE_CONTACT_FAILURE, CREATE_CONTACT_SUCCESS, EDIT_CONTACT_FAILURE, EDIT_CONTACT_SUCCESS } from '@tamalelibs/redux/app.actions';
import { NotificationStyles, NotificationOptions } from '../../widgets/notification/notification.model';
import { catchError, debounceTime, take } from 'rxjs/operators';
import { AppState } from '../../redux';
import { DialogAction } from '../../widgets/tam-dialog/tam-dialog.model';
import { ContactService } from '@tamalelibs/services/contact.service';
import { ContactTemplateControlValue } from '@tamalelibs/models/contact-template-control-value.model';
import { ContactTemplateType, ContactTemplateOpenOptions, ControlId, CompanyAction, JobTitleAction, ContactAction, NavigationAction, RelationshipAction, EmailAction, ContactRelationshipType, NameAction } from '../contact-dialog-new/contact-dialog.model';
import { ContactTemplateService } from '../contact-dialog-new/contact-template.service';
import { RelationshipTypeActionTypes } from '../../redux/actions/relationship-type.actions';
import { JobFunction, SocialMedia, PhoneDetail, EmailDetail, AddressDetail, EmploymentDetail, RelationshipDetail } from '@tamalelibs/models/job-function';
import { Entity } from '@tamalelibs/models/entity.model';
import { contactNewAddedJobTitleSelector, contactTemplateConfigSelector } from '@tamalelibs/redux/contact.reducer';
import { ContactRelationshipService } from '@tamalelibs/services/contact.relationship.service';
import { businessConstants } from '@tamalelibs/constants/business.constants';
import { DuplicatedContactItemConfigField, DuplicatedContactItemConfig } from '../duplicated-contact-dialog/duplicated-item/duplicated-item.model';
import { UUID } from 'angular2-uuid';
import { DuplicatedContactDialogService } from '../duplicated-contact-dialog/duplicated-contact-dialog.service';
import { CLEAR_JOB_TITLE } from '@tamalelibs/redux/contact.actions';
import { fromEvent } from 'rxjs';
import { ViewContainerRef } from '@angular/core';
import { EntityBack } from '../entity-dialog/entity-dialog.model';
import { EntityType } from '@tamalelibs/models/entity-type.model';
import { RelationshipType } from '@tamalelibs/models/relationship-type.model';
import { StoreQuerierService } from '../../services/store-querier.service';
import { SystemUser } from '@tamalelibs/models/user.model';
import { RelationshipService } from '@tamalelibs/services/relationship.service';
import { ContactDialogSectionName } from '../contact-detail-new/contact-body-detail.model';
import { getSystemConfigState } from '../../redux/reducers/system-config-view.reducer';
import { StringLiteralsPipe } from '../../pipes/translate.pipe';
import { HomeViewModel } from '../../pages/home/home-view.model';
import { ExchangeContact } from '@tamalelibs/models/exchange-import.model';
import { AddInUtilities } from '../../services/utilities/addin-utilities';
import { validReg } from '../../constants/business.constants';
import { ArrayHelperService } from '@tamalelibs/services/array-helper.service';

@Component({
    selector: 'contact-dialog',
    templateUrl: './contact-dialog.component.html',
    styleUrls: ['./contact-dialog.component.scss'],
    standalone: false
})
export class ContactDialogComponent implements OnInit, OnDestroy {
    @Input() id;
    opened: boolean;
    dialogWidth = 710;
    titleName: string;
    isDialogClosedForPlugin = 10; // 10 stands for open;20 stands for close
    isShow = false;
    tplConfig: any;
    allTemplate: any;
    navigationConfig: any;
    isDuplicatedContactName = false;
    isDuplicatedContactEmail = false;
    viewContainer: ViewContainerRef;
    valueChangeSubject: Subject<ContactTemplateControlValue>;
    currentContactRelationshipAndEmployment: any;
    isCheckSynch: boolean;
    isCreateContact: boolean;
    isOpenedExchangeSync = false;
    isOfficeAddinMode = false;
    isProgressing = false;
    hasDuplicateContact = false;
    private _el: HTMLElement;
    private _destroySubscriptions: Array<Subscription> = [];
    private _dialogCloseDestroySubscriptions: Array<Subscription> = [];
    private dialogOpenOptions: any;
    private _currentContact: Contact;
    private _contactTemplateValueSet: any = {}; // mark the template control's values, based on controlId;
    private _contactToEntities = businessConstants.EntityTypes.Contact_Id;
    private _duplicatedControls = [];
    private _duplicatedContactEmail: Array<DuplicatedContactItemConfig> = [];
    private _duplicatedContactNameInfo: Array<DuplicatedContactItemConfig> = [];
    private _mergeDuplicateContactInfo: Array<DuplicatedContactItemConfig> = [];
    private _isRelationshipControlValueChanged = false;
    private _currentEmploymentJSON: any;
    private _formerEmploymentLayout: any;
    private _sectionIndex;
    private _currentUser: SystemUser;
    private _currentRelationshipArray = [];
    private _currentCompany: any;
    private _contactEmailGroupIds;
    private _systemConfig;

    constructor(
        private _element: ElementRef,
        private _alertWindow: AlertWindowService,
        private _contactViewModel: ContactViewModel,
        private _store: Store<AppState>,
        private _toast: ToastService,
        private _openDynamicComponentService: OpenDynamicComponentService,
        private _contactTemplateService: ContactTemplateService,
        private _contactService: ContactService,
        private _contactRelationshipService: ContactRelationshipService,
        private _storeQuerierService: StoreQuerierService,
        private _relationshipService: RelationshipService,
        private _duplicatedContactDialogService: DuplicatedContactDialogService,
        private _homeViewModel: HomeViewModel,
        private _renderer: Renderer2,
    ) {
        this._el = this._element.nativeElement;
        this._currentUser = this._storeQuerierService.getCurrentUser();
        this._systemConfig = this._storeQuerierService.queryBySelector(getSystemConfigState);
    }

    ngOnInit() {
        this.valueChangeSubject = new ReplaySubject<ContactTemplateControlValue>(10);
        this.titleName = 'New Contact';
        this._destroySubscriptions.push(
            this._store.pipe(select(lastCustomActionSelector),
            ).subscribe(action => this._actionMessageHandler(action)),
            this._contactTemplateService.dialogOpen$.subscribe((dialogOpenOptions: ContactTemplateOpenOptions) => {
                if (this.id === dialogOpenOptions.instanceId) { // has a minimize dialog
                    if (dialogOpenOptions.openType) {
                        if (this._systemConfig.exchange && this._systemConfig.exchange.enable) {
                            this.isOpenedExchangeSync = true;
                        } else {
                            this.isOpenedExchangeSync = false;
                        }
                        this.dialogOpenOptions = dialogOpenOptions;
                        this.navigationConfig = dialogOpenOptions.instanceId || '';
                        this.titleName = this.dialogOpenOptions.openType;
                        this.opened = true;
                        this.isCheckSynch = false;
                        this._setFlyName();
                        this._initOfficeAddIn(dialogOpenOptions);
                        this.isCreateContact = this.dialogOpenOptions.openType === ContactTemplateType.NewContact;
                        if (this.dialogOpenOptions.contact && (this.dialogOpenOptions.openType === ContactTemplateType.EditContact || this.dialogOpenOptions.isSignature)) {
                            this._currentContact = _lodash.cloneDeep(this.dialogOpenOptions.contact);
                            if (this.dialogOpenOptions.isSignature) {
                                this._setDulpicateData({ 'contact-list': this._currentContact.duplicateContact }, false);
                                this.hasDuplicateContact = this._currentContact.duplicateContact.length > 0;
                            }
                            if (this._currentContact.relationships) {
                                this.currentContactRelationshipAndEmployment = this._convertRelationshipForEdit(this._currentContact.relationships);
                                this.processJobTitleToEmployment();
                            }
                        }
                        // after opened dialog get template from store.
                        this._dialogCloseDestroySubscriptions.push(
                            this._store.pipe(select(contactTemplateConfigSelector)).subscribe(res =>
                                this._initContactTemplate(res)
                            ));
                        // tslint:disable-next-line: no-shadowed-variable
                        this._contactViewModel.templateValueSet(this.dialogOpenOptions.instanceId).subscribe(res => this._setTemplateValue(res));
                        this._watchControlValueChange();
                        this._store.dispatch({
                            type: RelationshipTypeActionTypes.GETVALIDRELATIONSHIP
                        });
                    }
                }
            }),
        );
    }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(subscription => subscription.unsubscribe());
    }

    onClickSetEventValue(e: Event) {
        if (this.dialogOpenOptions) {
            e[this.dialogOpenOptions.eventKey] = this.dialogOpenOptions.eventValue;
        }
    }

    viewDuplicated() {
        // merge duplicate contact for email and name.
        this._mergeDuplicateContactInfo = [];
        if (this._duplicatedContactEmail.length > 0) {
            this._duplicatedContactEmail.forEach(emaiItem => {
                this._mergeDuplicateContactInfo.push(emaiItem);
            });
            this._duplicatedContactNameInfo.forEach(nameItem => {
                const index = this._duplicatedContactEmail.findIndex(item => item.contactId === nameItem.contactId);
                if (index < 0) {
                    this._mergeDuplicateContactInfo.push(nameItem);
                }
            });
        } else {
            this._mergeDuplicateContactInfo = this._duplicatedContactNameInfo;
        }

        // need to make sure the view duplicate dialog has the same instanceId with the contact dialog
        // because will close it together
        // and then if have more than one contact dialog, will know which contact dialog will close
        this._duplicatedContactDialogService.dialogOpen$.next({
            type: DialogAction.OpenDialog,
            payload: this._mergeDuplicateContactInfo
        });
    }

    // dialog open
    public open() {
        this.opened = true;
    }

    // TODO: Creating a contact on the task. need to improve or need to summary it.
    onContactDialogClick(event) {
        event['slideSheet'] = true;
    }

    onContainerEvent(event) {
        this.viewContainer = event;
    }

    onEnter(value) {
        if (this.opened) {
            this.clickClose();
        }
    }

    onCancelBtnClick(event: Event) {
        this.clickClose();
        // TAM-36788 to solve the issue that the side sheet will be closed when clicking the close/cancel button.
        if (event.stopPropagation) {
            event.stopPropagation();
        }
    }

    clickClose() {
        if (!this._contactTemplateService.changeValueStatus) {
            this.opened = false;
            this._setDialogCloseForPlugin();
            this._clearData();
            this._openDynamicComponentService.feedbackSubject$.next(DialogAction.CloseDialog);
        } else {
            const subscription = this._alertWindow.warn('You have unsaved changes', ['Are you sure you want to discard all your changes?'], 'Discard', 'Go Back', this.dialogOpenOptions.eventKey, this.dialogOpenOptions.eventValue)
                .subscribe((result: boolean) => {
                    if (result) {
                        this.opened = false;
                        this._setDialogCloseForPlugin();
                        this._clearData();
                        this._openDynamicComponentService.feedbackSubject$.next(DialogAction.CloseDialog);
                    }
                    subscription.unsubscribe();
                });
        }
    }

    // the keydown event should not be propagated to parent window
    @HostListener('keydown', ['$event'])
    handleKeydown(event: KeyboardEvent) {
        event.stopPropagation();
    }

    keySend(event) {
        if (event.ctrlKey && event.keyCode === 13) {
            this.publish();
        }
    }

    /**
     * click contact
     * 1.process all values to contact obj
     * 2.valid input value
     * 3.create Realtionshp
     * @memberof ContactDialogComponent
     */
    publish() {
        this._processInputValue();
        // this._createRelationship();
        if (this._verifyInput()) {
            this.isProgressing = true;
            // format phone number after verify
            for (const item of this._currentContact.webPhone) {
                const originalValue = _lodash.cloneDeep(item.phone);
                item.phone = item.phone.trim().split('-').join('');
                if (findPhoneNumbersInText(item.phone).length === 1) {
                    item.phone = parsePhoneNumber(item.phone).formatInternational().split(' ').join('-');
                } else if (/^([0-9]{10})$/.test(item.phone)) {
                    item.phone = item.phone.substring(0, 3) + '-' + item.phone.substring(3, 6) + '-' + item.phone.substring(6, 10);
                } else {
                    item.phone = originalValue;
                }
            }
            this._createRelationship();
        }
    }

    private _initOfficeAddIn(dialogOpenOptions: ContactTemplateOpenOptions) {
        // we also need to change style on the edit contact dialog which will be prompted on the condition that there is duplicate contact existed.
        // so change the office add-in mode justification to cover that case.
        if (AddInUtilities.isOfficeJSLoaded() && this._el.querySelector('.contact-template')) {
            this._renderer.addClass(this._el.querySelector('.contact-template'), 'contact_dialog_container');
        }
    }

    private _synchTamaleContactToExchagne(id) {
        this._contactService.synchTamaleIntoExchange(id, { 'operation': 'sync', 'syncType': 2 }).pipe(
            take(1),
        ).subscribe(data => {
        },
            error => {
                const _failedToast: NotificationOptions = {
                    message: error.message,
                    style: NotificationStyles.Error

                };
                this._toast.notify(_failedToast);
            }
        );
    }

    private _actionMessageHandler(action) {
        if (!action.prefix) {
            action.prefix = '';
        }
        if (this.dialogOpenOptions && action.prefix === this.dialogOpenOptions.instanceId) {
            if (action.type === CREATE_CONTACT_SUCCESS) {
                this.isProgressing = false;
                const contact = action.payload;
                if (this.isCheckSynch) {
                    this._synchTamaleContactToExchagne(contact.id);
                }
                if (this.dialogOpenOptions && this.dialogOpenOptions.entityBack) {
                    this._feedBackToPrivousDialog(contact);
                }
                this._clearData();
                this.opened = false;
                this._setDialogCloseForPlugin();
                const successMessage = 'Contact ' + action.payload.name + ' successfully created.';
                const _successToast: NotificationOptions = {
                    message: successMessage,
                    style: NotificationStyles.Success
                };
                this._toast.notify(_successToast);
                this._openDynamicComponentService.feedbackSubject$.next(DialogAction.CloseDialog);
            } else if (action.type === EDIT_CONTACT_SUCCESS) {
                this.isProgressing = false;
                const successMessage = 'Contact ' + action.payload.name + ' successfully updated.';
                const _successToast: NotificationOptions = {
                    message: successMessage,
                    style: NotificationStyles.Success
                };
                if (AddInUtilities.isOfficeEnvironment()) {
                    this._feedBackToPrivousDialog(action.payload, true);
                }
                this._clearData();
                this.opened = false;
                this._setDialogCloseForPlugin();
                this._toast.notify(_successToast);
            } else if (action.type === EDIT_CONTACT_FAILURE || action.type === CREATE_CONTACT_FAILURE) {
                this.isProgressing = false;
            }
        }
    }

    private _createValidRelationshipRequest(id) {
        return this._contactRelationshipService.createValidRelationship(this._contactToEntities, id)
            .pipe(
                catchError((err) => {
                    return of(null);
                }));
    }

    private _clearData() {
        this._currentContact = null;
        this._contactTemplateValueSet = null;
        this.tplConfig = null;
        this._contactTemplateService.changeValueStatus = false;
        this._contactViewModel.cleanTemplateValueSet(this.dialogOpenOptions.instanceId);
        this._contactViewModel.cleanTemplateMsg(this.dialogOpenOptions.instanceId);
        this._contactViewModel.reset(this.dialogOpenOptions.instanceId);
        this._dialogCloseDestroySubscriptions.forEach(item => item.unsubscribe());
        this._dialogCloseDestroySubscriptions = [];
        this._duplicatedContactEmail = [];
        this._duplicatedContactNameInfo = [];
        this._mergeDuplicateContactInfo = [];
        this.isDuplicatedContactName = false;
        this.isDuplicatedContactEmail = false;
        this.dialogOpenOptions = null;
        this.valueChangeSubject = null;
        this.allTemplate = null;
        this._currentCompany = null;
        // if close the dialog, we need to clear the store data
        this._store.dispatch({
            type: CLEAR_JOB_TITLE
        });
    }

    /**
     * if edit jobTitle from richClient .should be convert jobTitle to currentEmployment
     *
     * @private
     * @memberof ContactDialogComponent
     */
    private processJobTitleToEmployment() {
        // set dynamic layout for current employment
        // if (this.currentContactRelationshipAndEmployment.currentEmployment.length > 0) {
        const currentEmployment = [];
        if (this.currentContactRelationshipAndEmployment.currentEmployment.length !== this._currentContact.jobTitleWeb.length) {
            // the job title length > current employment length
            // for this part, will handle: if user add the invalid job title in richclient, the current employment should show
            this._currentContact.jobTitleWeb.forEach(jobTitleItem => {
                let _index = 0;
                if (this.currentContactRelationshipAndEmployment.currentEmployment.some((currentItem, index) => {
                    _index = index;
                    return jobTitleItem.id === currentItem.relationshipTypeId;
                })) {
                    currentEmployment.push({
                        id: jobTitleItem.id || '',
                        value: jobTitleItem.name || '',
                        startYear: this.currentContactRelationshipAndEmployment.currentEmployment[_index].startYear || '',
                        isEdit: true
                    });
                } else {
                    const fakeId = 'fakeId' + UUID.UUID();
                    if (jobTitleItem.name && !jobTitleItem['id']) {
                        jobTitleItem['id'] = fakeId;
                    }
                    // Fix for [TAM-35814] Create contact on RC with invalid company, after edit contact and create company on the fly, current employment relationship isn't created
                    currentEmployment.push({
                        id: jobTitleItem['id'],
                        value: jobTitleItem.name || '',
                        startYear: '',
                        isEdit: true
                    });
                }
            });
            this.currentContactRelationshipAndEmployment.currentEmployment = _lodash.cloneDeep(currentEmployment);
        }
    }

    /**
    * create relationship by restapi
    * 1.check is exist relationship type
    * 2.create no exist realtionship type
    * 3.create all invalid relationship
    */
    private _createRelationship() {
        this._store.pipe(
            select(contactNewAddedJobTitleSelector),
            take(1),
        ).subscribe(jobTitle => {
            let existRelationshipType = [];
            // to add this filter, so that we don't need to create this job title
            if (jobTitle && jobTitle.length > 0) {
                jobTitle = jobTitle.filter(element => element.count > 0);
            } else {
                jobTitle = [];
            }

            if (jobTitle.length === 0) {
                this._createContact();
            } else {
                const nameArray = jobTitle.map(item => item.name);
                this._contactRelationshipService.getValidRelationshipByName(nameArray).pipe(
                    catchError((err) => {
                        return of(null);
                    }),
                ).subscribe(res => {
                    existRelationshipType = res['exist'];
                    const noExist = res['not-exist'];
                    const newCreatedRelationshipTypeArray = []; // this var is to create this relationship type
                    const newCreatedValidRelationshipTypeArray = []; // this var is to change the new created relationship type to valid relationship type
                    noExist.forEach(item => {
                        newCreatedRelationshipTypeArray.push(
                            this._contactRelationshipService.createRelationshipType(item['name']));
                    });

                    let observable: Observable<any>;
                    if (newCreatedRelationshipTypeArray.length === 0) {
                        observable = new Observable(subscriber => {
                            subscriber.next(undefined);
                            subscriber.complete();
                        });
                    } else {
                        observable = forkJoin(newCreatedRelationshipTypeArray);
                    }
                    observable.subscribe(response => {
                        if (response && response.length > 0) {
                            response.forEach(res1 => {
                                if (res1) {
                                    newCreatedValidRelationshipTypeArray.push(this._createValidRelationshipRequest(res1['id']));
                                }
                            });
                        }
                        if (existRelationshipType.length > 0) {
                            existRelationshipType.forEach(item => {
                                newCreatedValidRelationshipTypeArray.push(this._createValidRelationshipRequest(item.ID));
                            });
                        }
                        if (newCreatedValidRelationshipTypeArray.length > 0) {
                            // the new created valid relationship may be the job title value, or employment value, or relationship value
                            forkJoin(newCreatedValidRelationshipTypeArray).subscribe(item => {
                                // now, for the current job title: only have the id value, including the fake id
                                // for the jobTitle in store, it will have the name and id(including the fake id)
                                // for the res, it will have the name and real id
                                // so, we need to get a mapping array
                                // new array: {original id, new id, name}
                                const mappingArray = [];
                                if (item && item.length > 0 && jobTitle && jobTitle.length > 0) {
                                    item.forEach(items => {
                                        jobTitle.forEach(element => {
                                            if (items['name'] === element.name) {
                                                mappingArray.push({
                                                    originalId: element.id,
                                                    newCreatedId: items['id'],
                                                    name: element.name
                                                });
                                            }
                                        });
                                    });
                                }

                                // here we need to adjust if the new added relationship type belongs to which part： only the mapping array length > 0
                                if (mappingArray.length > 0) {
                                    // first, we adjust if it belongs to job title control
                                    if (this._currentContact.jobTitle && this._currentContact.jobTitle.length > 0 && this._currentContact.jobTitle.filter(ele => ele.indexOf('fakeId') > -1).length > 0) {
                                        // it is that the job title control has the new added rel-type
                                        this._currentContact.jobTitle.forEach((element, index) => {
                                            if (element.indexOf('fakeId') > -1) {
                                                this._currentContact.jobTitle[index] = mappingArray.find(item1 => item1.originalId === element).newCreatedId;
                                            }
                                        });
                                    }

                                    // second, we adjust if it belongs to former employment part
                                    this._currentContact.employment.forEach((element, index) => {
                                        if (element.titleType && element.titleType[0] && element.titleType[0].indexOf('fakeId') > -1) {
                                            this._currentContact.employment[index].titleType[0] = mappingArray.find(item2 => item2.originalId === element.titleType[0]).newCreatedId;
                                        }
                                    });

                                    // third, we adjust if it belongs to relationship part
                                    this._currentContact.relationship.forEach((element, index) => {
                                        if (element.relationshipType.indexOf('fakeId') > -1) {
                                            this._currentContact.relationship[index].relationshipType = mappingArray.find(item3 => item3.originalId === element.relationshipType).newCreatedId;
                                        }
                                    });
                                }
                                this._createContact();
                            });
                        } else {
                            this._createContact();
                        }
                    });
                });
            }
        });
    }

    /**
     *
     *
     * @private
     * @param {*} nameValue
     * @memberof ContactDialogComponent
     */
    private _detectDuplicatedName(nameValue) {
        this.isDuplicatedContactName = false;
        this._duplicatedContactNameInfo = [];
        this._dialogCloseDestroySubscriptions.push(
            this._contactService.detectDuplicated([{
                field: 'name',
                value: nameValue
            }]).pipe(
                catchError((err) => {
                    return of(null);
                }),
            ).subscribe(res => {
                if (res && res.count > 0) {
                    this.isDuplicatedContactName = true;
                    this._setDulpicateData(res, true);
                }
            })
        );
    }

    private _detectDuplicatedEmail(newValue) {
        // only the duplicate controls can be added to the _duplicatedControls array
        const duplicateControlsIndex = this._duplicatedControls.findIndex(item =>
            newValue && item === newValue.emailControlID);
        if (duplicateControlsIndex > -1 || this._duplicatedContactEmail.length === 0) {
            this._duplicatedContactEmail = [];
            this._duplicatedControls.splice(duplicateControlsIndex, 1);
            this.isDuplicatedContactEmail = false;
            if (newValue.emailValue) {
                this._dialogCloseDestroySubscriptions.push(
                    this._contactService.detectDuplicated([{
                        field: 'webEmail',
                        value: newValue.emailValue
                    }]).pipe(
                        catchError((err) => {
                            return of(null);
                        }),
                    ).subscribe(res => {
                        if (res && res.count > 0) {
                            this._duplicatedControls.push(newValue.emailControlID);
                            // show the alert message
                            this.isDuplicatedContactEmail = true;
                            this._setDulpicateData(res, false);
                        }
                    })
                );
            }
        }
    }

    /**
     * process duplicate contact for display in duplicate contact dialog.
     *
     * @private
     * @param {*} res
     * @param {boolean} [isFromName=false]
     * @memberof ContactDialogComponent
     */
    private _setDulpicateData(res, isFromName = false) {
        res['contact-list'].forEach(listItem => {
            // parse duplicate contact ,due to it is reused with exchange contact model.
            const duplicateContact: ExchangeContact = ExchangeContact.parse(listItem);
            let jobTitle = '';
            const contactInfo = [];
            // get the job title value
            if (duplicateContact.webJobTitle && duplicateContact.webJobTitle.length > 0) {
                duplicateContact.webJobTitle.forEach((jobTitleItem, index) => {
                    if (index > 0) {
                        jobTitle = jobTitle + ', ' + jobTitleItem['name'];
                    } else {
                        jobTitle = jobTitleItem['name'];
                    }
                });
                contactInfo.push(
                    {
                        field: DuplicatedContactItemConfigField.JobTitle,
                        value: jobTitle
                    }
                );
            }
            // get the company value
            if (duplicateContact.webCompany && duplicateContact.webCompany.name) {
                contactInfo.push(
                    {
                        field: DuplicatedContactItemConfigField.Company,
                        value: duplicateContact.webCompany.name
                    }
                );
            }
            // get the web email value
            if (duplicateContact.webEmail && duplicateContact.webEmail.length > 0) {
                duplicateContact.webEmail.forEach(emailItem => {
                    let emailField = '';
                    if (emailItem['primaryEmail']) {
                        emailField = DuplicatedContactItemConfigField.PrimaryEmail;
                    } else {
                        emailField = emailItem['name'] + ' Email';
                    }
                    contactInfo.push({
                        field: emailField,
                        value: emailItem['address']
                    });
                });
                if (!isFromName) {
                    if (this._duplicatedContactNameInfo.findIndex(item => item.contactId === duplicateContact.id) === -1) {
                        this._duplicatedContactEmail.push({
                            contactName: duplicateContact.firstName + ' ' + duplicateContact.lastName,
                            contactId: duplicateContact.id,
                            contactInfo: contactInfo,
                            instanceId: this.dialogOpenOptions.instanceId,
                            controlId: this.dialogOpenOptions.entityBack ? this.dialogOpenOptions.entityBack.controlId : ''
                        });
                    }
                }
            }

            if (isFromName) {
                if (this._duplicatedContactNameInfo.findIndex(item => item.contactId === duplicateContact.id) === -1) {
                    this._duplicatedContactNameInfo.push({
                        contactName: duplicateContact.firstName + ' ' + duplicateContact.lastName,
                        contactId: duplicateContact.id,
                        contactInfo: contactInfo,
                        instanceId: this.dialogOpenOptions.instanceId,
                        controlId: this.dialogOpenOptions.entityBack ? this.dialogOpenOptions.entityBack.controlId : ''
                    });
                }
            }
        });
    }

    /**
     * save Contact Information (create or edit)
     * @memberof ContactDialogComponent
     */
    private _createContact() {
        if (this.dialogOpenOptions.openType === ContactTemplateType.NewContact) {
            // Ifsignature mode ,employment should be filter if titletype is undefind.
            if (this.dialogOpenOptions.isSignature && this._currentContact.employment && this._currentContact.employment.length > 0) {
                this._currentContact.employment = this._currentContact.employment.filter(item => item.titleType && item.titleType.length > 0 && item.titleType[0]);
            }
            this._contactViewModel.createContact(this._currentContact, this.dialogOpenOptions.instanceId);
            this._contactViewModel.setContactStatusCreate();
        } else if (this.dialogOpenOptions.openType === ContactTemplateType.EditContact) {
            this._contactViewModel.setContactStatusEdit();
            // only relationship control value changed, will send the request to server for update
            if (this._currentContact.relationship && this._currentContact.relationship.length > 0) {
                this._deleteMultiContactRelationshipType();
                this._createMultiContactRelationshipType();
            }
            this._contactViewModel.editContact(this._currentContact, this.dialogOpenOptions.instanceId);
        }
    }

    private _createMultiContactRelationshipType() {
        // for this function, we need to divide to three parts:
        // the entities and the topic member and the is in team
        // so, first, we need to get the create common entities request vars
        // then, we need to get the is in team request vars if the is in team exists
        // and get the topic member vars if the topic member exists
        const relationshipTypesArray = [];
        const entitiesArray = [];
        this._currentContact.relationship.forEach(item => {
            const index = relationshipTypesArray.findIndex(ele => ele === item.relationshipType);
            const newEntities = item.childEntity.map(element => element).join(',');
            if (index > -1) {
                entitiesArray[index] = entitiesArray[index] + ',' + newEntities;
            } else {
                relationshipTypesArray.push(item.relationshipType);
                entitiesArray.push(newEntities);
            }
        });

        const isInTeamLocation = relationshipTypesArray.indexOf(RelationshipType.IS_IN_TEAM.id);
        const topicMemberLocation = relationshipTypesArray.indexOf(RelationshipType.TOPIC_MEMBER.id);
        const addEntityObj = {};
        const isInteamOrTopicMemberObj = {
            childEntity: this._currentContact.id,
            parentEntity: {},
        };

        // for is in team
        if (isInTeamLocation > -1) {
            const isInTeamParentArray = [];
            entitiesArray[isInTeamLocation].split(',').forEach(element => {
                isInTeamParentArray.push(element);
            });
            isInteamOrTopicMemberObj.parentEntity[businessConstants.RelationshipTypes.IS_IN_TEAM_ID] = isInTeamParentArray;
            relationshipTypesArray.splice(isInTeamLocation, 1);
            entitiesArray.splice(isInTeamLocation, 1);
        }
        // for topic member
        if (topicMemberLocation > -1) {
            const topicMemberParentArray = [];
            entitiesArray[topicMemberLocation].split(',').forEach(element => {
                topicMemberParentArray.push(element);
            });
            isInteamOrTopicMemberObj.parentEntity[businessConstants.RelationshipTypes.TOPIC_MEMBER_ID] = topicMemberParentArray;
            relationshipTypesArray.splice(topicMemberLocation, 1);
            entitiesArray.splice(topicMemberLocation, 1);
        }

        addEntityObj['relType'] = relationshipTypesArray.join(',');
        addEntityObj['parentEntity'] = this._currentContact.id;
        addEntityObj['childEntity'] = entitiesArray.join(';');
        addEntityObj['isCreateReciprocal'] = true;
        addEntityObj['isAppend'] = false;

        this._relationshipService.createMultipleRelationship(addEntityObj).pipe(
            catchError((err) => {
                this._toast.notify({
                    message: err.message,
                    style: NotificationStyles.Error
                });
                return of(null);
            })
        ).subscribe(response => {
            // only have the team or topic member, will send below request to server
            if ((isInTeamLocation > -1 || topicMemberLocation > -1) && this._currentUser.credential.manageTeam) {
                this._relationshipService.creatIsInTeamOrTopicMemberRelationship(isInteamOrTopicMemberObj).pipe(
                    catchError((err) => {
                        this._toast.notify({
                            message: err.message,
                            style: NotificationStyles.Error
                        });
                        return of(null);
                    })
                ).subscribe(res => { });
            }
        });
    }

    private _deleteMultiContactRelationshipType() {
        const relationshipTypes = this._currentContact.relationship.map(item => item.relationshipType);
        const tempRelationshipArray = this._currentRelationshipArray.filter(item => !relationshipTypes.includes(item));
        if (tempRelationshipArray.length !== 0) {
            const addEntityObj = {};
            addEntityObj['relTypeId'] = tempRelationshipArray.join(',');
            addEntityObj['parentEntity'] = this._currentContact.id;
            addEntityObj['deletereciprocal'] = true;
            this._relationshipService.deleteRelationshipType(addEntityObj).pipe(
                catchError((err) => {
                    return of(null);
                })
            ).subscribe(data => { });
        }
    }

    private _createCurrentEmployment(originalCompany, targetCompany) {
        // tslint:disable-next-line: forin
        for (const index in this._contactTemplateValueSet) {
            const ctrl = this._contactTemplateValueSet[index];
            if (ctrl.ctrl.controlID === 'JobTitle') {
                const jobTitleIdArray = ctrl.value.split(',');
                const jobTitleNameArray = ctrl.displayValue.split(',');
                const currentEmployment = [];
                for (let i = 0; i < jobTitleIdArray.length; i++) {
                    currentEmployment.push({
                        id: jobTitleIdArray[i],
                        value: jobTitleNameArray[i],
                        startYear: 0,
                        isEdit: true
                    });
                }
                this._handleEmploymentJobtitle(currentEmployment);
                break;
            }
        }
    }

    private _convertRelationshipForEdit(relationships) {
        // to save 5 values: relationship id, child entity id, realtionship type name, relationship id, child entity name
        let _relationships = []; // [{{relationshiptype}: [{entities}]},{{relationshiptype}: [{entities}]}]
        const _currentEmployment = [];
        const _formerEmployment = [];
        if (relationships) {
            relationships.forEach(element => {
                if (!element.nodesType && !element.startYear && !element.endYear) {
                    let _index = 0;
                    let _nodeType = '';
                    let _isNodeEditable = true;
                    if (element.relationshipType.id === RelationshipType.IS_IN_TEAM.id) {
                        _nodeType = RelationshipType.IS_IN_TEAM.name;
                        if (this._currentUser.credential.manageTeam) {
                            _isNodeEditable = true;
                        } else {
                            _isNodeEditable = false;
                        }
                    } else if (element.relationshipType.id === RelationshipType.TOPIC_MEMBER.id) {
                        _nodeType = RelationshipType.TOPIC_MEMBER.name;
                        if (this._currentUser.credential.manageTeam) {
                            _isNodeEditable = true;
                        } else {
                            _isNodeEditable = false;
                        }
                    } else {
                        if (element.childEntity.type.id === EntityType.CONTACT.id &&
                            element.parentEntity.type.id === EntityType.CONTACT.id) {
                            _nodeType = ContactRelationshipType.Contact;
                        } else {
                            _nodeType = ContactRelationshipType.ContactAll;
                        }
                    }
                    // to get the relationships array: [{{relationshiptype}: [{entities}]},{{relationshiptype}: [{entities}]}]
                    if (_relationships.some((item, index, _tempArray) => {
                        _index = index;
                        return item.relationshipType.relationshipTypeId === element.relationshipType.id;
                    })) {
                        // has existed the relationship type
                        // just need to get the first entity's isEditable
                        _relationships[_index].relationshipEntities.push({
                            relationshipId: element.relationshipId,
                            childEntityName: element.childEntity.name,
                            childEntityId: element.childEntity.id,
                            nodeType: _nodeType,
                        });
                    } else {
                        // new added relationship type
                        const _tempRelationshipTypeArray = {
                            relationshipTypeId: element.relationshipType.id,
                            relationshipTypeName: element.relationshipType.name,
                            isNodeEditable: _isNodeEditable,
                        };
                        const _tempRelationshipEntitiesArray = [{
                            relationshipId: element.relationshipId,
                            childEntityName: element.childEntity.name,
                            childEntityId: element.childEntity.id,
                            nodeType: _nodeType,
                            isNodeEditable: _isNodeEditable,
                        }];
                        _relationships.push({
                            relationshipType: _tempRelationshipTypeArray,
                            relationshipEntities: _tempRelationshipEntitiesArray,
                        });
                    }
                } else if (element.nodesType === 'currentEmployment') {
                    _currentEmployment.push({
                        id: element.relationshipType.id || '',
                        value: element.relationshipType.name || '',
                        startYear: this._parseTimeToStandardTime(element.startYear),
                    });
                } else if (element.nodesType === 'formerEmployment') {
                    _formerEmployment.push({
                        relationshipId: element.relationshipId,
                        childEntityName: element.childEntity.name,
                        childEntityId: element.childEntity.id,
                        relationshipTypeId: element.relationshipType.id,
                        relationshipTypeName: element.relationshipType.name,
                        startYear: this._parseTimeToStandardTime(element.startYear),
                        endYear: this._parseTimeToStandardTime(element.endYear)
                    });
                }
            });
        }
        // if nodeType equals contact ,need  to pull out a separate array to display it
        let contactRelationArray = [];
        let entityRelationArray = [];
        const _relationshipAll = _lodash.cloneDeep(_relationships);
        _relationships.forEach((item, index) => {
            contactRelationArray[index] = item;
            contactRelationArray[index].relationshipType.relationshipTypeName += ' (Contact)';
            contactRelationArray[index].relationshipEntities =
                item.relationshipEntities.filter(entity => entity.nodeType === ContactRelationshipType.Contact);
        });
        contactRelationArray = contactRelationArray.filter(item => item.relationshipEntities.length > 0);
        _relationshipAll.forEach((item, index) => {
            entityRelationArray[index] = item;
            entityRelationArray[index].relationshipEntities =
                item.relationshipEntities.filter(entity => entity.nodeType !== ContactRelationshipType.Contact);
        });
        entityRelationArray = entityRelationArray.filter(item => item.relationshipEntities.length > 0);
        _relationships = entityRelationArray.concat(contactRelationArray);
        // Why is the order reversed ? due to _handleEmploymentJobtitle use index --
        ArrayHelperService.sort(_currentEmployment, 'startYear');
        ArrayHelperService.sort(_formerEmployment, 'endYear', false, true);
        return {
            relationships: _relationships,
            currentEmployment: _currentEmployment,
            formerEmployment: _formerEmployment
        };
    }

    /**
     *
     * feedback to note/entity dialog
     * @private
     * @param {Contact} contact
     * @memberof ContactDialogComponent
     */
    private _feedBackToPrivousDialog(contact: Contact, isEdit = false) {
        const entityBack = new EntityBack();
        entityBack.controlId = this.dialogOpenOptions.entityBack ? this.dialogOpenOptions.entityBack.controlId : '';
        entityBack.entityId = contact.id;
        entityBack.searchValue = contact.name;
        entityBack.currentId = this.dialogOpenOptions.instanceId;
        entityBack.primaryEmail = contact.primaryEmail;
        entityBack.jobTitle = contact.jobTitle;
        entityBack.companyWeb = contact.companyWeb;
        entityBack.isEditMode = isEdit;
        if (AddInUtilities.isOfficeEnvironment() && (entityBack.currentId === '1' || entityBack.currentId.includes('EDIT_CONTACT'))) {
            Office.context.ui.messageParent(JSON.stringify(entityBack));
        } else {
            this._openDynamicComponentService.feedbackSubject$.next(entityBack);
        }
    }

    /**
     * got current and former employment layout for dynamic created
     *
     * @private
     * @param {*} item
     * @memberof ContactDialogComponent
     */
    private _getEmploymentLayout(item) {
        switch (item.config.controlID) {
            case ControlId.CurrentEmploment:
                this._currentEmploymentJSON = _lodash.cloneDeep(item);
                break;
            case ControlId.FormerEmployment:
                this._formerEmploymentLayout = _lodash.cloneDeep(item);
                break;
        }
    }

    private _getEmploymentSectionIndex() {
        this.tplConfig.forEach((section, i) => {
            if (section.sectionName === ContactDialogSectionName.Employment) {
                this._sectionIndex = i;
            }
        });
    }

    private _moveCurrentEmploymentToFormerEmployment(originalCompany, targetCompany) {
        if (originalCompany) {
            // tslint:disable-next-line: forin
            for (const index in this._contactTemplateValueSet) {
                let originalCurrentEmployment;
                if (index.indexOf(ControlId.CurrentEmploment) !== -1 && this._contactTemplateValueSet[index].value) {
                    const _startYear = 0;
                    if (this._contactTemplateValueSet[index].ctrl.editValue) {
                        const _value = this._contactTemplateValueSet[index].ctrl.editValue;
                        originalCurrentEmployment = {
                            relationshipId: this._contactTemplateValueSet[index].ctrl.editValue.id,
                            childEntityName: originalCompany.name || '',
                            childEntityId: originalCompany.id || '',
                            relationshipTypeId: _value.id,
                            relationshipTypeName: _value.value,
                            startYear: _value.startYear,
                            endYear: new Date().getFullYear()
                        };
                        const cEmploymentLayout = _lodash.cloneDeep(this._formerEmploymentLayout);
                        cEmploymentLayout.config.controlID = ControlId.FormerEmployment + '-' + UUID.UUID();
                        cEmploymentLayout.config.isCanDelete = true;
                        cEmploymentLayout.config.isHidden = false;
                        cEmploymentLayout.config.editValue = originalCurrentEmployment;
                        cEmploymentLayout.config.isSupportDynamic = false;
                        const formerLength = this.tplConfig[this._sectionIndex].container.length;
                        const lastFormerIndex = formerLength > 0 ? formerLength - 1 : 0;
                        this.tplConfig[this._sectionIndex].container.splice(lastFormerIndex, 0, new Array(cEmploymentLayout));
                        delete this._contactTemplateValueSet[index];
                    }
                }
            }
            // to clear the job title control
            this._contactTemplateService.actionSubject$.next({
                type: JobTitleAction.ClearJobTitile,
                payload: 'JobTitle'
            });
        }
    }

    private _parseTime(year: Number) {
        if (!year) {
            return 0;
        } else {
            const _currentYear = year.toString() + '/01/30 00:00:00';
            return (new Date(_currentYear)).getTime();
        }
    }

    private _parseTimeToStandardTime(milTime) {
        let date;
        if (milTime === 0) {
            date = '';
        } else {
            date = new Date(milTime).getFullYear();
        }
        return date;
    }

    private _setFlyName() {
        if (this.dialogOpenOptions && this.dialogOpenOptions.contact && this.dialogOpenOptions.isFly) {
            let flyName = this.dialogOpenOptions.contact.name;
            if (flyName) {
                flyName = flyName.trim();
                if (flyName.indexOf(' ') > -1) {
                    const spaceIndex = flyName.indexOf(' ');
                    const firstName = flyName.substring(0, spaceIndex);
                    const lastName = flyName.substring(spaceIndex + 1, flyName.length);
                    this.dialogOpenOptions.contact.name = firstName;
                    this.dialogOpenOptions.contact.lastName = lastName;
                }
            }
        }
    }

    /**
     * open contact from blastemail or on the fly,need set default value
     * @private
     * @param {*} item
     * @memberof ContactDialogComponent
     */
    private _setValueForBlastemailOrFlyContact(item) {
        if (this.dialogOpenOptions && (this.dialogOpenOptions.isBlastEmail || this.dialogOpenOptions.isPaticipant)) {
            if (item.config.controlID === ControlId.FirstName) {
                item.config.defaultValue = this.dialogOpenOptions.contact.name;
            } else if (item.config.controlID === ControlId.LastName) {
                item.config.defaultValue = this.dialogOpenOptions.contact.lastName;
            } else if (item.config.controlID === ControlId.Email) {
                item.config['defaultValueEmail'] = this.dialogOpenOptions.contact.primaryEmail;
            }
        }
        if (this.dialogOpenOptions && this.dialogOpenOptions.contact && this.dialogOpenOptions.isFly) {
            if (item.config.controlID === ControlId.FirstName) {
                item.config.defaultValue = this.dialogOpenOptions.contact.name;
            } else if (item.config.controlID === ControlId.LastName) {
                item.config.defaultValue = this.dialogOpenOptions.contact.lastName;
            }
        }
    }

    /**
     * add addtional config for create or edit
     * @private
     * @memberof ContactDialogComponent
     */
    private _setTemplateConfig() {
        for (const sections of this.tplConfig) {
            if (sections.container && sections.container.length === 0) {
                sections['isHidden'] = true;
            } else {
                sections['isHidden'] = false;
            }
            for (let index = sections.container.length - 1; index >= 0; index--) {
                const content = sections.container[index];
                for (const item of content) {
                    item.config['action'] = this.dialogOpenOptions.openType;
                    item.config['prefixId'] = this.id;
                    item.config['secSName'] = sections.secSName;
                    item.config['sectionId'] = sections.sectionId;
                    item.config['isSignature'] = this.dialogOpenOptions.isSignature;
                    this._setValueForBlastemailOrFlyContact(item);
                    this._getEmploymentLayout(item);
                    if (this.dialogOpenOptions.contact && (this.dialogOpenOptions.openType === ContactTemplateType.EditContact || this.dialogOpenOptions.isSignature)) {
                        this._currentRelationshipArray = [];
                        // tslint:disable-next-line: no-shadowed-variable
                        if (this.currentContactRelationshipAndEmployment && this.currentContactRelationshipAndEmployment.relationships) {
                            this.currentContactRelationshipAndEmployment.relationships.forEach(rItem => {
                                this._currentRelationshipArray.push(rItem.relationshipType.relationshipTypeId);
                            });
                        }

                        switch (item.config.controlID) {
                            case ControlId.FirstName:
                                item.config['editValue'] = this._currentContact.firstName;
                                break;
                            case ControlId.LastName:
                                item.config['editValue'] = this._currentContact.lastName;
                                break;
                            case ControlId.Alias:
                                item.config['editValue'] = this._currentContact.aliases;
                                break;
                            case ControlId.Company:
                                // when send request to server, the company stands for companyid
                                // when get response from server, the company stands for a json: company id, company name, company short name
                                item.config['editValue'] = this._currentContact.companyWeb;
                                break;
                            case ControlId.JobTitle:
                                item.config['editValue'] = this._currentContact.jobTitleWeb;
                                break;
                            case ControlId.JobFunction:
                                item.config['editValue'] = this._currentContact.jobFunction ? this._currentContact.jobFunction.map(data => data.name) : [];
                                break;
                            case ControlId.Notes:
                                item.config['editValue'] = this._currentContact.notes;
                                break;
                            case ControlId.Birthday:
                                item.config['editValue'] = this._currentContact.birthday ? new Date(this._currentContact.birthday) : '';
                                break;
                            case ControlId.Prefix:
                                item.config['editValue'] = this._currentContact.attribute.prefix;
                                break;
                            case ControlId.Suffix:
                                item.config['editValue'] = this._currentContact.attribute.suffix;
                                break;
                            case ControlId.MiddleName:
                                item.config['editValue'] = this._currentContact.attribute.middleName;
                                break;
                            case ControlId.Gender:
                                item.config['editValue'] = this._currentContact.attribute.gender;
                                break;

                            case ControlId.EmploymentCompany:
                                if (this._currentContact.companyWeb) {
                                    item.config['editValue'] = this._currentContact.companyWeb.name;
                                }
                                break;
                            case ControlId.Email:
                                this.setDynamicLayout(this._currentContact.webEmail, item, sections.container, index);
                                break;
                            case ControlId.Internet:
                                this.setDynamicLayout(this._currentContact.socialMedia, item, sections.container, index);
                                break;
                            case ControlId.Phone:
                                this.setDynamicLayout(this._currentContact.webPhone, item, sections.container, index);
                                break;
                            case ControlId.Address:
                                this._currentContact.webAddress.forEach(data => {
                                    if (!data.country && !data.state && !data.street && data.originalAddress) {
                                        data.street = data.originalAddress;
                                    }
                                });
                                this.setDynamicLayout(this._currentContact.webAddress, item, sections.container, index);
                                break;
                            case ControlId.CurrentEmploment:
                                if (this.currentContactRelationshipAndEmployment && this.currentContactRelationshipAndEmployment.currentEmployment) {
                                    this.setDynamicLayout(this.currentContactRelationshipAndEmployment.currentEmployment, item, sections.container, index);
                                }

                                break;
                            case ControlId.FormerEmployment:
                                if (this.currentContactRelationshipAndEmployment && this.currentContactRelationshipAndEmployment.formerEmployment) {


                                    this.setDynamicLayout(this.currentContactRelationshipAndEmployment.formerEmployment, item, sections.container, index);
                                }
                                break;
                            case ControlId.Relationships:
                                if (this.currentContactRelationshipAndEmployment && this.currentContactRelationshipAndEmployment.relationships) {
                                    this.setDynamicLayout(this.currentContactRelationshipAndEmployment.relationships, item, sections.container, index);
                                }
                                break;
                        }
                    }
                }
            }
        }
    }

    private setDynamicLayout(obj, item, container, location) {
        if (obj && obj.length > 0) {
            obj.forEach((itemValue, index) => {
                if (index < obj.length && (index > 0 || (item.config.controlID === ControlId.FormerEmployment && index === 0))) {
                    const newCtrlJson = _lodash.cloneDeep(item);
                    newCtrlJson.config.controlID = newCtrlJson.config.controlID + UUID.UUID();
                    newCtrlJson.config.isCanDelete = true;
                    newCtrlJson.config.prefixId = this.dialogOpenOptions.instanceId;
                    newCtrlJson.config['editValue'] = obj[index];
                    newCtrlJson.config.isLabelHidden = true;
                    newCtrlJson.config.isHidden = false;
                    newCtrlJson.config.isSupportDynamic = false;
                    if (index === obj.length - 1 && item.config.controlID !== ControlId.FormerEmployment) {
                        newCtrlJson.config.isSupportDynamic = true;
                    }
                    if (item.config.controlID === ControlId.FormerEmployment) {
                        container.splice(location + index + 1, 0, new Array(newCtrlJson));
                    } else {
                        container.splice(location + index, 0, new Array(newCtrlJson));
                    }

                    if (item.config.controlID === ControlId.Email) {
                        this._contactViewModel.increment(newCtrlJson.config.controlID, newCtrlJson.config.prefixId);
                    }
                } else if (index === 0) {
                    item.config['editValue'] = obj[0];
                    if (obj.length > 1) {
                        item.config.isSupportDynamic = false;
                    }
                }
            });
        }
    }

    /**
     * set Template data for child component
     * @private
     * @param {*} res
     * @memberof ContactDialogComponent
     */
    private _initContactTemplate(res) {
        this.allTemplate = _lodash.cloneDeep(res);
        this.tplConfig = this.allTemplate.contains;
        this.allTemplate['dialogOpenOptions'] = this.dialogOpenOptions;
        fromEvent(window, 'mousewheel').pipe(
            debounceTime(250)
        ).subscribe((e: any) => {
            if (this.tplConfig) {
                const section = this.tplConfig.filter(item =>
                    !item.isHidden && this._el.getElementsByClassName(item.sectionId) && this._el.getElementsByClassName(item.sectionId)[0]['offsetTop'] >= this._el.querySelector('.tml-tpl-wrap').scrollTop)[0];
                this._contactTemplateService.actionSubject$.next({
                    type: NavigationAction.ChangeNavigationSection,
                    payload: {
                        name: section.sectionId,
                        instanceId: this.dialogOpenOptions.instanceId
                    }
                });
            }
        });
        this._getEmploymentSectionIndex();
        this._setTemplateConfig();
    }

    /**
     * get all input value from store
     * @param res
     */
    private _processInputValue() {
        // if edit contact ,we should keep last edit value ,even if control is hidden.
        if (!this._currentContact) {
            this._currentContact = new Contact();
        } else {
            this._resetContactParams();
        }
        this._currentContact.employment = new Array<EmploymentDetail>();
        if (this.dialogOpenOptions.openType === ContactTemplateType.EditContact) {
            this._currentContact.id = this.dialogOpenOptions.contact.id;
            this._currentContact.defaultRelationshipType = this.dialogOpenOptions.contact.defaultRelationshipType;
        }
        this._processSingleCtrlValue();
    }

    private _processSingleCtrlValue() {
        // tslint:disable-next-line: forin
        for (const controlId in this._contactTemplateValueSet) {
            const ctrl = this._contactTemplateValueSet[controlId];
            switch (controlId) {
                case ControlId.FirstName:
                    this._currentContact.firstName = ctrl.value;
                    break;
                case ControlId.LastName:
                    this._currentContact.lastName = ctrl.value;
                    break;
                case ControlId.Alias:
                    this._currentContact.aliases = ctrl.value;
                    break;
                case ControlId.Company:
                    // when send request to server, the company stands for companyid
                    // when get response from server, the company stands for a json: company id, company name, company short name
                    this._currentContact.company = ctrl.value;
                    break;
                case ControlId.JobTitle:
                    this._currentContact.jobTitle = ctrl.value.split(',');
                    break;
                case ControlId.JobFunction:
                    const jobfunction = new JobFunction();
                    jobfunction.new = ctrl.value;
                    this._currentContact.jobFunction = jobfunction;
                    break;
                case ControlId.Notes:
                    this._currentContact.notes = ctrl.value;
                    break;
                case ControlId.Birthday:
                    this._currentContact.birthday = ctrl.displayValue;
                    break;
                case ControlId.Prefix:
                    this._currentContact.attribute.prefix = ctrl.value;
                    break;
                case ControlId.Suffix:
                    this._currentContact.attribute.suffix = ctrl.value;
                    break;
                case ControlId.MiddleName:
                    this._currentContact.attribute.middleName = ctrl.value;
                    break;
                case ControlId.Gender:
                    this._currentContact.attribute.gender = ctrl.value;
                    break;
            }

            if (controlId.indexOf(ControlId.Internet) > -1 && ctrl.value.inputValue) {
                const socialMedia = new SocialMedia();
                socialMedia.name = ctrl.value.selectedItem;
                socialMedia.link = ctrl.value.inputValue;
                this._currentContact.socialMedia.push(socialMedia);
            } else if (controlId.indexOf(ControlId.Phone) > -1 && ctrl.value.inputValue) {
                const phoneDetail = new PhoneDetail();
                phoneDetail.phone = ctrl.value.inputValue;
                phoneDetail.name = ctrl.value.selectedItem;
                this._currentContact.webPhone.push(phoneDetail);
            } else if (controlId.indexOf(ControlId.Email) > -1 && ctrl.value.inputValue) {
                const emailDetail = new EmailDetail();
                emailDetail.address = ctrl.value.inputValue;
                emailDetail.name = ctrl.value.selectedItem;
                emailDetail.primaryEmail = ctrl.value['isPrimary'] || false;
                this._currentContact.webEmail.push(emailDetail);
                if (emailDetail.primaryEmail) {
                    // need find primaryEmail value for primaryEmail
                    this._currentContact.primaryEmail = emailDetail.address;
                }
            } else if (controlId.indexOf(ControlId.Address) > -1 && ctrl.isFromUser) {
                const addressDetal = new AddressDetail();
                addressDetal.name = ctrl.value.type;
                addressDetal.country = ctrl.value.country;
                addressDetal.street = ctrl.value.street;
                addressDetal.street2 = ctrl.value.street2;
                addressDetal.city = ctrl.value.city;
                addressDetal.state = ctrl.value.state;
                addressDetal.zip = ctrl.value.zip;
                this._currentContact.webAddress.push(addressDetal);
            } else if (controlId.indexOf(ControlId.FormerEmployment) > -1) {
                const formerEmployment = new EmploymentDetail();
                formerEmployment.titleType = [ctrl.value.titleType];
                formerEmployment.companyID = ctrl.value.companyID;
                formerEmployment.startDate = this._parseTime(Number(ctrl.value.startDate));
                formerEmployment.endDate = this._parseTime(Number(ctrl.value.endYear));
                this._currentContact.employment.push(formerEmployment);
            } else if (controlId.indexOf(ControlId.CurrentEmploment) > -1) {
                const currentEmployment = new EmploymentDetail();
                currentEmployment.titleType = [ctrl.value.titleType];
                currentEmployment.companyID = this._currentCompany ? this._currentCompany.id : '';
                currentEmployment.startDate = this._parseTime(Number(ctrl.value.startDate));
                this._currentContact.employment.push(currentEmployment);
            } else if (controlId.indexOf(ControlId.Relationships) > -1) {
                const relationship = new RelationshipDetail();
                relationship.relationshipType = ctrl.value.relationshipType;
                relationship.childEntity = ctrl.value.childEntity;
                this._currentContact.relationship.push(relationship);
            }
        }
    }

    /**
     * If edit model, array control should be reset.
     */
    private _resetContactParams() {
        this._currentContact.employment = [];
        this._currentContact.relationship = [];
        this._currentContact.webAddress = [];
        this._currentContact.webEmail = [];
        this._currentContact.webPhone = [];
        this._currentContact.socialMedia = [];
    }

    /**
     * save current Employment
     * This function need to save current employment when user create the invalid company and then click the cancel button
     * the current employment should be saved though user click the cancel button
     * @private
     * @param {Entity} newCreatedCompany
     * @memberof ContactDialogComponent
     */
    private _saveCurrentEmployment(newCreatedCompany: Entity): void {
        // tslint:disable-next-line: forin
        for (const index in this._contactTemplateValueSet) {
            const ctrl = this._contactTemplateValueSet[index];
            if (ctrl.ctrl.controlID === 'JobTitle') {
                const currentEmployment = {
                    contactID: this._currentContact.id,
                    companyID: newCreatedCompany.id,
                    startDate: 0,
                    titleType: ctrl.value.split(','),
                };
                this._contactService.createContactEmployment(currentEmployment).subscribe(res => { });
            }
        }
    }

    private _setTemplateValue(res) {
        this._contactTemplateValueSet = res;
    }

    /**
     *  watch control change action and  set value
     *  actionList :
     *    1.CompanyAction.ChangeCompany ;CompanyAction.CreateValidCompany;CompanyAction.CreateInvalidCompany
     *    2.ContactAction AddControl RemoveControl
     *    3.
     * @private
     * @param {*} res
     * @memberof ContactDialogComponent
     */
    private _watchControlValueChange() {
        this._dialogCloseDestroySubscriptions.push(
            this._contactTemplateService.actionSubject$.subscribe(action => {
                this._processCommnonAction(action);
                if (this.dialogOpenOptions && this.dialogOpenOptions.contact && this.dialogOpenOptions.openType === ContactTemplateType.EditContact) {
                    this._processActionForEdit(action);
                } else if (this.dialogOpenOptions && this.dialogOpenOptions.openType === ContactTemplateType.NewContact) {
                    if (action.type === EmailAction.ChangeEmailValue && action.payload && action.payload.prefix === this.dialogOpenOptions.instanceId) {
                        this._detectDuplicatedEmail(action.payload);
                    } else if (action.type === NameAction.ChangeNameValue) {
                        let firstName;
                        let lastName;
                        // after received firstName or lastName change ,get value by _contactTemplateValueSet
                        for (const index in this._contactTemplateValueSet) {
                            if (index === ControlId.FirstName) {
                                firstName = this._contactTemplateValueSet[index].value;
                            } else if (index === ControlId.LastName) {
                                lastName = this._contactTemplateValueSet[index].value;
                            }
                        }
                        if (firstName && lastName) {
                            this._detectDuplicatedName(firstName + lastName);
                        } else {
                            this.isDuplicatedContactName = false;
                        }
                    }
                }
            }),
            this._contactViewModel.getContactEamilCount(this.dialogOpenOptions.instanceId).subscribe(res => this._contactEmailGroupIds = res),
        );
    }

    private _processActionForEdit(action) {
        if (action.type === CompanyAction.ChangeCompany) {
            // this._currentCompany = action.payload.targetCompany;
            this._moveCurrentEmploymentToFormerEmployment(action.payload.originalCompany, action.payload.targetCompany);
        } else if (action.type === CompanyAction.CreateValidCompany) {
            // Not sure if this deletion has any effect. Comment out Marcus
            // this._createCurrentEmployment(action.payload.originalCompany, action.payload.targetCompany);
            this._moveCurrentEmploymentToFormerEmployment(action.payload.originalCompany, action.payload.targetCompany);
        } else if (action.type === CompanyAction.CreateInvalidCompany) {
            // this._createCurrentEmployment(action.payload.originalCompany, action.payload.targetCompany);
            this._saveCurrentEmployment(action.payload.targetCompany);
        }
    }

    private _processCommnonAction(action) {
        // for relationship action
        if ((action.type === RelationshipAction.ChangeRelationshipEntity ||
            action.type === RelationshipAction.ChangeRelationshipType) && !this._isRelationshipControlValueChanged) {
            this._isRelationshipControlValueChanged = true;
        }
        // for change job title action
        if (this.dialogOpenOptions && action.type === JobTitleAction.ChangeJobTitle && action.prefixId === this.dialogOpenOptions.instanceId) {
            this._handleEmploymentJobtitle(action.payload);
        }
        // for navigation action
        if (action.type === NavigationAction.ChangeDialogSection) {
            this._changeDialogSection(action.payload);
        }
        // for dialog close
        if (action.type === DialogAction.CloseDialog && action.payload.instanceId === this.id) {
            this.opened = false;
            this._contactTemplateService.changeValueStatus = false;
            this._setDialogCloseForPlugin();
            // need remove this dialog from dom.
            this.clickClose();
        }
        if (action.type === ContactAction.AddControl || action.type === ContactAction.RemoveControl) {
            this._addOrRemvoeControl(action);
        }
        if (action.type === CompanyAction.SetCompanyValue) {
            this._currentCompany = action.payload.company;
        }
    }

    /**
     * Add  control
     *
     * @private
     * @memberof ContactDialogComponent
     */
    private _addOrRemvoeControl(action) {
        const payload = action.payload;
        // tslint:disable-next-line: forin
        for (const sectionIndex in this.tplConfig) {
            const section = this.tplConfig[sectionIndex];
            if (section['secSName'] === payload.secSName) {
                const layouts = section.container;
                for (let index = layouts.length - 1; index >= 0; index--) {
                    if (layouts[index][0].config.controlID === payload.controlID) {
                        if (action.type === ContactAction.AddControl) {
                            // payload.ctrl.controlID = payload.ctrl.config.controlID;
                            if (payload.controlID !== ControlId.FormerEmployment) {
                                layouts[index][0].config.isSupportDynamic = false;
                            }
                            layouts.splice(index + 1, 0, new Array(payload.ctrl));
                        } else if (action.type === ContactAction.RemoveControl) {
                            for (const key in this._contactTemplateValueSet) {
                                if (key === payload.controlID) {
                                    delete this._contactTemplateValueSet[key];
                                }
                            }
                            if (layouts[index][0].config.isSupportDynamic) {
                                layouts[index - 1][0].config.isSupportDynamic = true;
                            }
                            layouts.splice(index, 1);
                        }
                    }
                }
            }
        }
    }

    // need to move to ct-text component
    // this function will do: when jobtitle changed in basic information, current employment should add the same
    // control according to the jobtitle
    private _handleEmploymentJobtitle(res) {
        let currentJobTitle = [];
        res.forEach(element => {
            let startYear = '';
            if (this.dialogOpenOptions.openType === ContactTemplateType.EditContact) {
                startYear = element.startYear;
            }
            for (const index in this._contactTemplateValueSet) {
                if (index.indexOf(ControlId.CurrentEmploment) !== -1 && element.id === this._contactTemplateValueSet[index]['value'].titleType) {
                    startYear = this._contactTemplateValueSet[index]['value'].startDate;
                }
            }
            currentJobTitle.push({ id: element.id, value: element.value, startYear: startYear });
        });
        for (const index in this._contactTemplateValueSet) {
            if (index.indexOf(ControlId.CurrentEmploment) !== -1) {
                delete this._contactTemplateValueSet[index];
            }
        }
        if (currentJobTitle.length === 0) {
            currentJobTitle = [''];
        }
        this.tplConfig.forEach((section, i) => {
            if (section.sectionName === ContactDialogSectionName.Employment) {
                this._sectionIndex = i;
                for (let k = section.container.length - 1; k >= 0; k--) {
                    const value = section.container[k][0];
                    if (value.config.controlID.indexOf(ControlId.CurrentEmploment) !== -1) {
                        section.container.splice(k, 1);
                    }
                }
            }
        });
        currentJobTitle.forEach((item, i) => {
            const cEmploymentValue = _lodash.cloneDeep(this._currentEmploymentJSON);
            cEmploymentValue.config['defaultValue'] = item;
            if (this.dialogOpenOptions.openType === ContactTemplateType.EditContact) {
                cEmploymentValue.config['editValue'] = item;
            }
            cEmploymentValue.config.controlID = ControlId.CurrentEmploment + '-' + UUID.UUID();
            this.tplConfig[this._sectionIndex].container.splice(1, 0, new Array(cEmploymentValue));
        });
    }

    private _changeDialogSection(config) {
        if (config && this.dialogOpenOptions && config.instanceId === this.dialogOpenOptions.instanceId) {
            const value = this._el.getElementsByClassName(config.name)[0]['offsetTop'];
            this._el.querySelector('.tml-tpl-wrap').scrollTop = value;
        }
    }

    private _verifyInput() {
        const firstNameCondition = this._currentContact.firstName && this._currentContact.firstName.indexOf(',') < 1;
        const lastNameCondition = this._currentContact.lastName && this._currentContact.lastName.indexOf(',') < 1;
        const formerEmploymentEndDateCondition
            = this._currentContact.employment.filter(item =>
                item.hasOwnProperty('endDate') && (item.endDate === 0)).length === 0;
        const allEmail = this._currentContact.webEmail.filter(item => item.address && (!validReg.emailReg.test(item.address))).length === 0;
        // To verify international phone number formating.When edit a contact, the phone number has been formatted,and we need to transform it before verify.
        const allPhone = this._currentContact.webPhone.filter(item => item.phone && !((validReg.countryFullReg.test(item.phone.split('-').join(''))) || (findPhoneNumbersInText(item.phone.split('-').join('')).length))).length === 0;
        let _validAllControls = null;
        this.tplConfig.forEach((section) => {
            section.container.forEach(element => {
                element.forEach(item => {
                    for (const index in this._contactTemplateValueSet) {
                        if (index === ControlId.Email) {
                            if (this._contactTemplateValueSet[index].ctrl && this._contactTemplateValueSet[index].ctrl.isPrimary && !this._contactTemplateValueSet[index].value.inputValue && this._contactTemplateValueSet[index].ctrl.isRequired) {
                                _validAllControls = item.config.sectionId;
                            }
                        } else {
                            if (index === item.config.controlID && item.config.isRequired && index.indexOf(ControlId.Email) < 0) {
                                if ((this._contactTemplateValueSet[index].value.length === 0 ||
                                    (this._contactTemplateValueSet[index].value.hasOwnProperty('inputValue') && !this._contactTemplateValueSet[index].value.inputValue)) && !_validAllControls) {
                                    _validAllControls = item.config.sectionId;
                                    return;
                                } else if (index.indexOf(ControlId.Address) > -1 && item.config.isRequired) {
                                    const address = this._contactTemplateValueSet[index].value;
                                    if (!address.street || !address.state || !address.city) {
                                        _validAllControls = item.config.sectionId;
                                    }
                                }
                            }
                        }
                    }
                });
            });
        });
        if (_validAllControls) {
            this._setNotify();
        }
        if (firstNameCondition && formerEmploymentEndDateCondition && allEmail && allPhone && !_validAllControls) {
            if (this._currentContact.lastName) {
                if (lastNameCondition) {
                    return true;
                } else {
                    this._setNotify(true, true, true);
                    return false;
                }
            } else {
                return true;
            }
        } else {
            // scroll control to first required . on hold this scenario
            // let name = 'sec1';
            // if (!firstNameCondition) {
            //     name = 'sec1';
            // } else if (!allPhone || !allEmail) {
            //     name = 'sec2';
            // } else if (!formerEmploymentEndDateCondition) {
            //     name = 'sec4';
            // } else {
            //     name = _validAllControls;
            // }
            // const location = { 'instanceId': this.dialogOpenOptions.instanceId, 'name': name };
            // this._changeDialogSection(location);
            this._contactTemplateService.validInputSubject$.next({ 'prefixId': this.dialogOpenOptions.instanceId, 'allPhone': allPhone, 'allEmail': allEmail });
            if (firstNameCondition) {
                this._setNotify(allEmail, allPhone);
            } else {
                this._setNotify(allEmail, allPhone, true);
            }
            return false;
        }
    }

    /**
     * only for web plugin
     * the value of 'hidden-note-dialog' should be 20px after click save/close/save draft button
     */
    private _setDialogCloseForPlugin() {
        this.isDialogClosedForPlugin = 20;
    }

    private _setNotify(allEmail = true, allPhone = true, illegalChar = false) {
        let mesage = StringLiteralsPipe.translate('general.required_error_message');
        if (!allPhone) {
            mesage = 'Invalid Phone Number.';
        } else if (!allEmail) {
            mesage = 'Invalid Email Address.';
        } else if (illegalChar) {
            mesage = StringLiteralsPipe.translate('general.contain_illegal_characters');
        }
        const _errorToast: NotificationOptions = {
            message: mesage,
            style: NotificationStyles.Error
        };
        this._toast.notify(_errorToast);
    }
}
